import { render, staticRenderFns } from "./learn.vue?vue&type=template&id=bef25688&scoped=true&"
import script from "./learn.vue?vue&type=script&lang=js&"
export * from "./learn.vue?vue&type=script&lang=js&"
import style0 from "./learn.vue?vue&type=style&index=0&id=bef25688&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef25688",
  null
  
)

export default component.exports